<template>
  <v-autocomplete
    v-bind="$attrs"
    v-on="$listeners"
    :items="items"
    filled
    dense
  ></v-autocomplete>
</template>

<script>
 // same as property type
  export default {
    name: 'SiteType',
    data: () => ({
      items: [
        {
          text: 'Rooftop',
          value: 'Rooftop',
        },
        {
          text: 'Existing Tower',
          value: 'Existing Tower',
        },
        {
          text: 'Indoor System',
          value: 'Indoor System',
        },
        {
          text: 'Tunnel',
          value: 'Tunnel',
        },
        {
          text: 'Rooftop & Indoor System',
          value: 'Rooftop & Indoor System',
        },
        {
          text: 'Greenfield',
          value: 'Greenfield',
        },
      ],
    }),
  }
</script>

<style scoped>

</style>
